'use es6';

import { PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW } from 'DesignData/actions/ActionTypes';
export default function PreviewerWindow(state = null, action) {
  switch (action.type) {
    case PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW:
      {
        const {
          previewWindow
        } = action;
        if (!previewWindow) return state;
        return previewWindow;
      }

    default:
      return state;
  }
}